import { compose } from '../reactApolloCompat';
import { withSnackbarMessage } from '../context/SnackbarMessage';
import withTheme from '@mui/styles/withTheme';
import { IconButton, ListItemButton } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import React, { Component } from 'react';
import * as Icons from '../component/IconIndex';
import { AddIcon, CloseIcon } from '../component/IconIndex';
import Grid from '../component/form/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Paper from '@mui/material/Paper';
import PrimaryButton, {
    AltButton,
    DestroyButton,
    ModalPrimaryButton,
    OutlineButton,
    SaveButton
} from '../component/form/PrimaryButton';
import LinkButton from '../component/form/LinkButton';
import ActionButton from '../component/form/ActionButton';
import Icon from '@mui/material/Icon';
import ColumnLayout, { SnappableLayout } from '../component/ColumnLayout';
import ButtonWrapper from './workQueue2/extras/Button';
import BiggerMessageBar from '../component/BiggerMessageBar';
import Typography from '../component/Typography';
import Modal from './workQueue2/extras/Modal';
import AlertModal from './workQueue2/extras/AlertModal';
import { WhiteLoader } from '../component/WhiteLoader';
import Spinner from '../component/Spinner';
import HtmlEditor from '../component/form/HtmlEditor';
import { createForm } from '../util/form';
import { getCurrentUser } from '../environment';
import TextField from '../component/form/TextField';
import { InlineField } from '../component/form/Inline';
import Select from '../component/form/Select';
import RadioGroup from '../component/form/RadioGroup';
import Checkbox from '../component/form/Checkbox';
import OptionalTextField from '../component/form/OptionalTextField';
import AddressAutocomplete, { COMPONENT } from '../component/form/AddressAutocomplete';
import AddressBookAutocomplete from '../component/form/AddressBookAutocomplete';
import ComboListAutoComplete from '../component/form/ComboListAutoComplete';
import AutoComplete from '../component/form/AutoComplete';
import StaffAutoComplete from '../component/form/StaffAutoComplete';
import FamilyMemberAutocomplete from '../component/form/FamilyMemberAutocomplete';
import FileUpload from '../component/form/FileUpload';
import StaffGroupAutoComplete from '../component/form/StaffGroupAutoComplete';
import Snackbar from '@mui/material/Snackbar';
import Inline from './workQueue2/extras/Inline';
import Table, {
    TableCell,
    TableHeaderCell,
    TableHeaderRow,
    TableRow,
    TableSecondaryHeaderRow
} from '../component/form/Table';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';

class IconsPreview extends Component {
    state = {
        activeTab: 0,
        openModal1: false,
        openModal2: false,
        openModal3: false,
        openModal4: false,
        openModal5: false,
        openModal6: false,
        openModal7: false,
        openModal8: false,
        openSnackbar: true,
        form: createForm(this, {
            DemoEditor: null,
            text1: 'Sample text'
        })
    };

    render() {
        const { activeTab } = this.state;
        const { classes } = this.props;
        return (
            <Paper>
                <Tabs
                    variant="scrollable"
                    scrollButtons
                    value={activeTab}
                    onChange={(evt, idx) => this.setState({ activeTab: idx })}
                    allowScrollButtonsMobile
                >
                    <Tab label="Icons" />
                    <Tab label="Buttons" />
                    <Tab label="Messages" />
                    <Tab label="Fonts" />
                    <Tab label="Modals" />
                    <Tab label="Layouts" />
                    <Tab label="Spinners" />
                    <Tab label="Form Fields" />
                    <Tab label="Tables" />
                </Tabs>
                <Grid pc={1} style={{ padding: '12px 24px' }}>
                    <Grid container spacing={1} className={classes.outerGrid}>
                        {activeTab === 0 && this.renderIcons()}
                        {activeTab === 1 && this.renderButtons()}
                        {activeTab === 2 && this.renderMessages()}
                        {activeTab === 3 && this.renderFonts()}
                        {activeTab === 4 && this.renderModals()}
                        {activeTab === 5 && this.renderLayouts()}
                        {activeTab === 6 && this.renderSpinners()}
                        {activeTab === 7 && this.renderFormFields()}
                        {activeTab === 8 && this.renderTables()}
                    </Grid>
                </Grid>
            </Paper>
        );
    }

    renderIcons() {
        return Object.keys(Icons).map(key => {
            const Icon = Icons[key];
            return (
                <Grid item xs={6} md={3} key={key}>
                    <Icon value={66} /> &nbsp;&lt;{key}/&gt;
                </Grid>
            );
        });
    }

    renderButtons() {
        const { classes } = this.props;
        return (
            <ColumnLayout>
                <div className={classes.buttonList}>
                    <Grid item xs={12}>
                        Simple Buttons
                    </Grid>
                    <Grid item xs={12}>
                        <PrimaryButton>PrimaryButton</PrimaryButton>
                        {'<PrimaryButton/>'}
                        <br />
                        Basic button, default.
                    </Grid>
                    <Grid item xs={12}>
                        <AltButton>AltButton</AltButton>
                        {'<AltButton/>'}
                        <br />
                        Highlighted action.
                    </Grid>
                    <Grid item xs={12}>
                        <OutlineButton>OutlineButton</OutlineButton>
                        {'<OutlineButton/>'}
                        <br />
                        Cancel, close or minor action.
                    </Grid>
                    <Grid item xs={12}>
                        <SaveButton>SaveButton</SaveButton>
                        {'<SaveButton/>'}
                        <br />
                        Write/save to database. Immediate action.
                    </Grid>
                    <Grid item xs={12}>
                        <DestroyButton>DestroyButton</DestroyButton>
                        {'<DestroyButton/>'}
                        <br />
                        Write/delete to database. Immediate action.
                    </Grid>
                    <Grid item xs={12}>
                        <LinkButton href={'#'} text={'text'}>
                            LinkButton
                        </LinkButton>
                        {'<LinkButton text="text" href/>'}
                        <br />
                        Link
                    </Grid>
                    <Grid item xs={12}>
                        <IconButton size="large">
                            <Icon>delete</Icon>
                        </IconButton>
                        {'<IconButton/>'}
                        <br />
                        Icons.
                    </Grid>
                </div>
                <div className={classes.buttonList}>
                    <Grid item xs={12}>
                        <div style={{ width: 150, display: 'inline-block' }}>
                            <ActionButton text={'ActionButton'}></ActionButton>
                        </div>
                        {'<ActionButton icon text/>'}
                        <br />
                        Action button
                    </Grid>
                    <Grid item xs={12} key={1}>
                        <ButtonWrapper icon={<AddIcon />}>ButtonWrapper</ButtonWrapper>
                        {'<ButtonWrapper icon>text</ButtonWrapper>'}
                        <br />
                        Include an icon.
                    </Grid>
                    <Grid item xs={12} key={2}>
                        <ButtonWrapper endIcon={<AddIcon />}>ButtonWrapper</ButtonWrapper>
                        {'<ButtonWrapper endIcon/>'}
                        <br />
                        Include an icon at the end.
                    </Grid>
                    <Grid item xs={12} key={3}>
                        <ButtonWrapper icon={<AddIcon />} />
                        {'<ButtonWrapper icon/>'}
                        <br />
                        Icon button
                    </Grid>
                    <Grid item xs={12} key={4}>
                        <Inline>
                            <ButtonWrapper variant="tag" onClick={() => undefined}>
                                I'm a tag!
                            </ButtonWrapper>
                            <ButtonWrapper variant="tag primary" onClick={() => undefined}>
                                primary
                            </ButtonWrapper>
                            <ButtonWrapper variant="tag secondary" onClick={() => undefined}>
                                secondary
                            </ButtonWrapper>
                            <ButtonWrapper variant="tag tertiary" onClick={() => undefined}>
                                tertiary
                            </ButtonWrapper>
                            <ButtonWrapper variant="tag quaternary" onClick={() => undefined}>
                                quaternary
                            </ButtonWrapper>
                        </Inline>
                        <Inline>
                            <ButtonWrapper variant="tag">no OnClick!</ButtonWrapper>
                            <ButtonWrapper variant="tag primary">primary</ButtonWrapper>
                            <ButtonWrapper variant="tag secondary">secondary</ButtonWrapper>
                            <ButtonWrapper variant="tag tertiary">tertiary</ButtonWrapper>
                            <ButtonWrapper variant="tag quaternary">quaternary</ButtonWrapper>
                        </Inline>
                        {'<ButtonWrapper variant="tag"/>'}
                        <br />
                        Tag
                    </Grid>
                    <Grid item xs={12} key={5}>
                        <ButtonWrapper variant="link" href="#">
                            I'm a link!
                        </ButtonWrapper>
                        {'<ButtonWrapper variant="link" href/>'}
                        <br />
                        Link
                    </Grid>
                </div>
            </ColumnLayout>
        );
    }

    renderMessages() {
        const { openSnackbar } = this.state;
        return (
            <Grid item xs={12}>
                <BiggerMessageBar>Default (info) message</BiggerMessageBar>
                <BiggerMessageBar messageType="good">"good" message</BiggerMessageBar>
                <BiggerMessageBar messageType="error">"error" message</BiggerMessageBar>
                <BiggerMessageBar messageType="approve">"approve" message</BiggerMessageBar>
                <BiggerMessageBar messageType="warning">"warning" message</BiggerMessageBar>
                <BiggerMessageBar messageType="loading">"loading" message</BiggerMessageBar>
                <Snackbar
                    sx={{ '& .MuiSnackbarContent-root': { width: '100%', maxWidth: 'none' } }}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={openSnackbar}
                    message={
                        <div style={{ color: 'black', margin: '-22px -26px' }}>
                            <BiggerMessageBar messageType="update">
                                <p>
                                    <strong>Snackbar example!</strong>
                                </p>
                                <LinkButton onClick={() => this.setState({ openSnackbar: false })}>
                                    <CloseIcon />
                                </LinkButton>
                            </BiggerMessageBar>
                        </div>
                    }
                />
            </Grid>
        );
    }

    renderFonts() {
        return (
            <>
                <Grid item xs={6}>
                    <pre>{'<Typography variant="..." />'}</pre>
                    <Typography>Default, no variant</Typography>
                    <Typography variant={'h1'}>h1</Typography>
                    <Typography variant={'h2'}>h2</Typography>
                    <Typography variant={'h3'}>h3</Typography>
                    <Typography variant={'h4'}>h4</Typography>
                    <Typography variant={'h5'}>h5</Typography>
                    <Typography variant={'h6'}>h6</Typography>
                    <Typography variant={'subtitle1'}>subtitle1</Typography>
                    <Typography variant={'subtitle2'}>subtitle2</Typography>
                    <Typography variant={'button'}>button</Typography>
                    <Typography variant={'body1'}>body1</Typography>
                    <Typography variant={'body2'}>body2</Typography>
                    <Typography variant={'caption'}>caption</Typography>
                    <Typography variant={'overline'}>overline</Typography>
                </Grid>
                <Grid item xs={6}>
                    <pre>{`<p/>`}</pre>
                    <p>
                        v3 deprecated variants — sizes differ from h1-h6, not available in v4, so inline styles applied.
                    </p>
                    <Typography variant="display4">display4 (h1)</Typography>
                    <Typography variant="display3">display3 (h2)</Typography>
                    <Typography variant="display2">display2 (h3)</Typography>
                    <Typography variant="display1">display1 (h4)</Typography>
                    <Typography variant="headline">headline (h5)</Typography>
                    <Typography variant="title">title (h6)</Typography>
                    <Typography variant="subheading">subheading (span)</Typography>
                    <pre>{`<ol start><li/></ol>`}</pre>
                    <ol start={2}>
                        <li>ol list item 1</li>
                        <li>
                            ol list item 2
                            <ol>
                                <li>nested item</li>
                            </ol>
                        </li>
                        <li>ol list item 3</li>
                    </ol>
                    <pre>{`<ul/>`}</pre>
                    <ul>
                        <li>ul list item 1</li>
                        <li>
                            ul list item 2
                            <ul>
                                <li>nested item</li>
                            </ul>
                        </li>
                        <li>ul list item 3</li>
                    </ul>
                    <pre>{`<List component="nav"><ListItem button/><ListItemButton/>`}</pre>
                    <List component="nav">
                        <ListItem button>ListItem button</ListItem>
                        <ListItemButton>ListItemButton</ListItemButton>
                    </List>
                </Grid>
            </>
        );
    }

    renderModals() {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <PrimaryButton
                        onClick={() => {
                            this.setState({ openModal1: true });
                        }}
                    >
                        Primary Modal
                    </PrimaryButton>
                    <pre>{`<Modal open onClose canClickOut title subtitle>`}</pre>
                    <Modal
                        open={this.state.openModal1}
                        onClose={() => {
                            this.setState({ openModal1: false });
                        }}
                        title="Title"
                        subtitle="Subtitle"
                        canClickOut={true}
                    >
                        <Typography variant={'body1'}>
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                        </Typography>
                        <Typography
                            variant="h6"
                            style={{ fontSize: '1.15rem', lineHeight: '1.17em', margin: '9.75px 0' }}
                        >
                            {' '}
                            Use 'Esc' button or click outside to close the modal.
                        </Typography>
                    </Modal>
                </Grid>
                <Grid item md={4}>
                    <PrimaryButton
                        onClick={() => {
                            this.setState({ openModal2: true });
                        }}
                    >
                        Simple Modal
                    </PrimaryButton>
                    <pre>{`<Modal variant="simple">`}</pre>
                    <Modal
                        open={this.state.openModal2}
                        onClose={() => {
                            this.setState({ openModal2: false });
                        }}
                        variant="simple"
                    >
                        <Typography variant={'body1'}>
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                        </Typography>
                    </Modal>
                </Grid>
                <Grid item md={4}>
                    <PrimaryButton
                        onClick={() => {
                            this.setState({ openModal3: true });
                        }}
                    >
                        Task Modal
                    </PrimaryButton>
                    <pre>{`<Modal variant="task">`}</pre>
                    (Not used anymore)
                    <Modal
                        open={this.state.openModal3}
                        onClose={() => {
                            this.setState({ openModal3: false });
                        }}
                        title="Title"
                        subtitle="Subtitle"
                        variant="task"
                        taskid="task-1"
                    >
                        <Typography variant={'body1'}>
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                        </Typography>
                        <Typography
                            variant="h6"
                            style={{ fontSize: '1.15rem', lineHeight: '1.17em', margin: '9.75px 0' }}
                        >
                            {' '}
                            Use 'Esc' button or click outside to close the modal.
                        </Typography>
                    </Modal>
                </Grid>
                <Grid item md={4}>
                    <PrimaryButton
                        onClick={() => {
                            this.setState({ openModal4: true });
                        }}
                    >
                        Stepped Modal
                    </PrimaryButton>
                    <pre>{`<Modal variant="stepped" steps="[]">`}</pre>
                    <Modal
                        open={this.state.openModal4}
                        title="Title"
                        subtitle="Subtitle"
                        variant="stepped"
                        steps={[
                            {
                                abbreviation: 'Step 1',
                                title: 'Step 1',
                                subtitle: 'First Step',
                                button: <PrimaryButton>Next</PrimaryButton>,
                                content: (
                                    <Typography variant={'body1'}>
                                        This is the content for step 1. Lorem ipsum dolor sit amet.
                                    </Typography>
                                )
                            },
                            {
                                abbreviation: 'Step 2',
                                title: 'Step 2',
                                subtitle: 'Second Step',
                                button: <PrimaryButton>Continue</PrimaryButton>,
                                content: (
                                    <Typography variant={'body1'}>
                                        This is the content for step 2. Consectetuer adipiscing elit.
                                    </Typography>
                                )
                            },
                            {
                                abbreviation: 'Step 3',
                                title: 'Step 3',
                                subtitle: 'Third Step',
                                button: <PrimaryButton>Proceed</PrimaryButton>,
                                content: (
                                    <Typography variant={'body1'}>
                                        This is the content for step 3. Aenean commodo ligula eget dolor.
                                    </Typography>
                                )
                            },
                            {
                                abbreviation: 'Step 4',
                                title: 'Step 4',
                                subtitle: 'Fourth Step',
                                button: <PrimaryButton>Almost Done</PrimaryButton>,
                                content: (
                                    <Typography variant={'body1'}>
                                        This is the content for step 4. Aenean massa cum sociis natoque.
                                    </Typography>
                                )
                            },
                            {
                                abbreviation: 'Step 5',
                                title: 'Step 5',
                                subtitle: 'Final Step',
                                button: <PrimaryButton>Finish</PrimaryButton>,
                                content: (
                                    <Typography variant={'body1'}>
                                        This is the content for step 5. Donec quam felis ultricies nec.
                                    </Typography>
                                )
                            }
                        ]}
                    >
                        <hr />
                        <Typography variant={'body1'}>
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                        </Typography>
                        <ModalPrimaryButton
                            onClick={() => {
                                this.setState({ openModal4: false });
                            }}
                        >
                            Close
                        </ModalPrimaryButton>
                    </Modal>
                </Grid>
                <Grid item xs={12}>
                    <PrimaryButton
                        onClick={() => {
                            this.setState({ openModal8: true });
                        }}
                    >
                        Alert Modal
                    </PrimaryButton>
                    <pre>{`<AlertModal onClickPrimaryAction onClickSecondaryAction>`}</pre>
                    <AlertModal
                        open={this.state.openModal8}
                        onClose={() => {
                            this.setState({ openModal8: false });
                        }}
                        primaryAction="Primary Action"
                        onClickPrimaryAction={() => null}
                        secondaryAction="Secondary Action"
                        onClickSecondaryAction={() => null}
                    >
                        <Typography variant={'body1'}>
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                        </Typography>
                    </AlertModal>
                </Grid>
                <Grid item md={4}>
                    <PrimaryButton
                        onClick={() => {
                            this.setState({ openModal5: true });
                        }}
                    >
                        Alert Modal (save)
                    </PrimaryButton>
                    <pre>{`<AlertModal variant="save">`}</pre>
                    <AlertModal
                        open={this.state.openModal5}
                        onClose={() => {
                            this.setState({ openModal5: false });
                        }}
                        variant="save"
                        primaryAction="Primary Action"
                        onClickPrimaryAction={() => null}
                        secondaryAction="Secondary Action"
                        onClickSecondaryAction={() => null}
                    >
                        <Typography variant={'body1'}>
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                        </Typography>
                    </AlertModal>
                </Grid>
                <Grid item md={4}>
                    <PrimaryButton
                        onClick={() => {
                            this.setState({ openModal6: true });
                        }}
                    >
                        Alert Modal (warning)
                    </PrimaryButton>
                    <pre>{`<AlertModal variant="warning">`}</pre>
                    <AlertModal
                        open={this.state.openModal6}
                        onClose={() => {
                            this.setState({ openModal6: false });
                        }}
                        variant="warning"
                        primaryAction="Primary Action"
                        onClickPrimaryAction={() => null}
                        secondaryAction="Secondary Action"
                        onClickSecondaryAction={() => null}
                    >
                        <Typography variant={'body1'}>
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                        </Typography>
                    </AlertModal>
                </Grid>
                <Grid item md={4}>
                    <PrimaryButton
                        onClick={() => {
                            this.setState({ openModal7: true });
                        }}
                    >
                        Alert Modal (error)
                    </PrimaryButton>
                    <pre>{`<AlertModal variant="error">`}</pre>
                    <AlertModal
                        open={this.state.openModal7}
                        onClose={() => {
                            this.setState({ openModal7: false });
                        }}
                        variant="error"
                        primaryAction="Primary Action"
                        onClickPrimaryAction={() => null}
                        secondaryAction="Secondary Action"
                        onClickSecondaryAction={() => null}
                    >
                        <Typography variant={'body1'}>
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo
                        </Typography>
                    </AlertModal>
                </Grid>
            </Grid>
        );
    }

    renderLayouts() {
        const { showSnap } = this.state;
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h5" style={{ lineHeight: 1.35417 }}>
                        Column Layout
                    </Typography>
                    <pre>{`<ColumnLayout>children</ColumnLayout>`}</pre>
                    <ColumnLayout>
                        <Grid style={{ backgroundColor: 'red', minHeight: '200px' }} />
                        <Grid style={{ backgroundColor: 'green', minHeight: '200px' }} />
                        <Grid style={{ backgroundColor: 'blue', minHeight: '200px' }} />
                        <Grid style={{ backgroundColor: 'yellow', minHeight: '200px' }} />
                    </ColumnLayout>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h5" style={{ lineHeight: 1.35417 }}>
                        Snapped Layout
                    </Typography>
                    <PrimaryButton onClick={() => this.setState({ showSnap: !showSnap })}>
                        {!showSnap ? 'Show ' : 'Hide '} Snappable Component
                    </PrimaryButton>
                    <pre>{`<SnappableLayout snappableComponent>children</SnappableLayout>`}</pre>
                    <SnappableLayout
                        snappableComponent={
                            !!showSnap && (
                                <Grid style={{ backgroundColor: 'purple', minHeight: '200px', padding: '12px' }}>
                                    Snappable Component (appears on right on large screens, absolute positioned on
                                    mobile)
                                </Grid>
                            )
                        }
                    >
                        <Grid style={{ backgroundColor: 'red', minHeight: '200px', padding: '12px' }}>
                            Child Content Column 1
                        </Grid>
                        <Grid style={{ backgroundColor: 'green', minHeight: '200px', padding: '12px' }}>
                            Child Content Column 2
                        </Grid>
                    </SnappableLayout>
                </Grid>
            </Grid>
        );
    }

    renderSpinners() {
        return (
            <Grid container>
                <Grid item xs={12} md={6} style={{ position: 'relative', minHeight: '300px' }}>
                    <pre>{`<WhiteLoader actionWord='Loading'/>`}</pre>
                    <WhiteLoader actionWord="Loading" />
                </Grid>
                <Grid item>
                    <pre>{`<Spinner width="32" />`}</pre>
                    <Spinner width={32} />
                </Grid>
            </Grid>
        );
    }

    renderFormFields() {
        const substitutionFields = {
            '[[MysteryMeat]]': getCurrentUser().Email,
            '[[MissingData]]': null
        };
        const someOptions = [
            { label: 'First option', value: '1' },
            { label: 'Disabled option', value: '2', disabled: true },
            { label: 'Last option', value: '3' }
        ];
        const addressFields = {
            [COMPONENT.line1]: 'address1.AddressLine1',
            [COMPONENT.line2]: 'address1.AddressLine2',
            [COMPONENT.city]: 'address1.Suburb',
            [COMPONENT.state]: 'address1.State',
            [COMPONENT.code]: 'address1.Postcode',
            [COMPONENT.country]: 'address1.Country'
        };
        const { form } = this.state;
        return (
            <ColumnLayout>
                <Grid container>
                    <Grid bucket>
                        <Grid item xs={12}>
                            <pre>{`<TextField form name label multiline />`}</pre>
                            <TextField form={form} name="text1" label="The label" multiline />
                        </Grid>
                        <Grid item>
                            <pre>{`<TextField type="number|date|time" />`}</pre>
                            <InlineField>
                                <TextField type="number" form={form} name="textNum" />
                                <TextField type="date" form={form} name="textDate" />
                                <TextField type="time" form={form} name="textTime" />
                            </InlineField>
                        </Grid>
                    </Grid>
                    <Grid bucket>
                        <Grid item>
                            <div>Validation (use form validation, don't hardcode like these)</div>
                            <InlineField>
                                <TextField form={form} name="text1" validationResult={{ valid: false }} />
                                <TextField
                                    form={form}
                                    name="text1"
                                    validationResult={{ valid: true, requirement: 0 }}
                                />
                                <TextField
                                    form={form}
                                    name="text1"
                                    validationResult={{ valid: true, requirement: 1 }}
                                />
                            </InlineField>
                        </Grid>
                    </Grid>
                    <Grid bucket>
                        <Grid item xs={12}>
                            <pre>{`<Select options={[{label,value,disabled},]} />`}</pre>
                            <Select options={someOptions} form={form} name="select1" />
                        </Grid>
                        <Grid item xs={12}>
                            <pre>{`<RadioGroup options={[{label,value,disabled},]} label />`}</pre>
                            <RadioGroup label="The Label" options={someOptions} form={form} name="select1" />
                        </Grid>
                        <Grid item xs={12}>
                            <pre>{`<Checkbox label checked onChange disabled />`}</pre>
                            <InlineField>
                                <Checkbox label="Checkbox" form={form} name="check1" />
                                <Checkbox
                                    label="Checkbox"
                                    form={form}
                                    name="check2"
                                    validationResult={{ valid: false }}
                                />
                                <Checkbox label="Checkbox Disabled" form={form} name="check2" disabled />
                            </InlineField>
                        </Grid>
                    </Grid>
                    <Grid bucket>
                        <Grid item xs={12}>
                            <pre>{`<TextField/Checkbox/Select readOnly value />`}</pre>
                            <TextField value="I have some value" readOnly label="The label" />
                        </Grid>
                        <Grid item xs={12}>
                            <pre>{`<OptionalTextField buttonlabel textfieldlabel />`}</pre>
                            <OptionalTextField
                                form={form}
                                name="text2"
                                buttonlabel="+ Click me"
                                textfieldlabel="Clear me"
                            />
                        </Grid>
                    </Grid>

                    <Grid bucket>
                        <Grid item xs={12}>
                            <pre>{`<FileUpload />`}</pre>
                            <FileUpload label={'Upload Document'} form={form} name="file1" />
                        </Grid>
                        <Grid item>
                            <pre>{`<FileUpload iconButton />`}</pre>
                            <FileUpload iconButton label={'Upload Document'} form={form} name="file1" />
                        </Grid>
                        <Grid item>
                            <pre>{`<FileUpload iconOnly />`}</pre>
                            <FileUpload iconOnly label={'Upload Document'} form={form} name="file1" />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid bucket>
                        <Grid item>
                            <pre>{`<HtmlEditor shortcodes="{{code:value,}}" form name>`}</pre>
                            <HtmlEditor
                                placeholder="Enter body of note, or choose a new template..."
                                shortcodes={substitutionFields}
                                form={form}
                                name="DemoEditor"
                            />
                        </Grid>
                    </Grid>
                    <Grid bucket>
                        <Grid item xs={12}>
                            <pre>{`<StaffAutoComplete clearOnSelect=false preloadAll />`}</pre>
                            <StaffAutoComplete clearOnSelect={false} preloadAll />
                        </Grid>
                        <Grid item xs={12}>
                            <pre>{`<StaffGroupAutoComplete clearOnSelect=false multiple=false />`}</pre>
                            <StaffGroupAutoComplete label="Staff Group..." clearOnSelect={false} multiple={false} />
                        </Grid>
                        <Grid item xs={12}>
                            <pre>{`<AddressAutocomplete componentFields="{}" allowCustomAddress />`}</pre>
                            <AddressAutocomplete
                                label="Street Address"
                                form={form}
                                name="address1"
                                componentFields={addressFields}
                                allowCustomAddress
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <pre>{`<AddressBookAutocomplete noAddNew />`}</pre>
                            <AddressBookAutocomplete label="Supplier" form={form} name="address2" noAddNew />
                        </Grid>
                        <Grid item xs={12}>
                            <pre>{`<ComboListAutoComplete allowUnlisted category="OCCUPATION" />`}</pre>
                            <ComboListAutoComplete
                                label="Occupation"
                                form={form}
                                name="combo1"
                                category={'OCCUPATION'}
                                allowUnlisted
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <pre>{`<FamilyMemberAutocomplete funeralId />`}</pre>
                            <FamilyMemberAutocomplete label="Family relatives" funeralId={12345} />
                        </Grid>
                        <Grid item xs={12}>
                            <pre>{`<AutoComplete options={[{label,value,disabled},]} />`}</pre>
                            <AutoComplete
                                label="Simple styled autocomplete"
                                name="combo3"
                                form={form}
                                options={someOptions}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <pre>{`<TextField list={[{label,value,disabled},]} />`}</pre>
                            <TextField
                                label="Simple native-styled autocomplete"
                                form={form}
                                name="combo2"
                                list={someOptions}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </ColumnLayout>
        );
    }

    renderTables() {
        const dummyEvent = {
            title: 'Event Title',
            brand: 'Brand Name',
            staff: 'Staff Member Name',
            instructions: 'Event-specific instructions go here.'
        };

        return (
            <ColumnLayout>
                <Grid container>
                    <Grid bucket>
                        <Grid item xs={12}>
                            <pre>
                                {`<Table className="table">
                                        <TableHeaderRow>
                                            <TableHeaderCell colSpan={2}>Title</TableHeaderCell>
                                        </TableHeaderRow>
                                        <TableSecondaryHeaderRow>
                                            <TableHeaderCell>Column 1</TableHeaderCell>
                                            <TableHeaderCell>Column 2</TableHeaderCell>
                                        </TableSecondaryHeaderRow>
                                        <TableRow className="row">
                                            <TableCell className="td" dataLabel="Column 1">
                                                Row 1, cell 1
                                            </TableCell>
                                            <TableCell className="td" dataLabel="Column 2">
                                                Row 1, cell 2
                                            </TableCell>
                                        </TableRow>
                                        <TableRow className="row">
                                            <TableCell className="td" dataLabel="Column 1">
                                                Row 2, cell 1
                                            </TableCell>
                                            <TableCell className="td" dataLabel="Column 2">
                                                Row 2, cell 2
                                            </TableCell>
                                        </TableRow>
                                        <TableRow className="row">
                                            <TableCell className="td" dataLabel="Column 1">
                                                Row 3, cell 1
                                            </TableCell>
                                            <TableCell className="td" dataLabel="Column 2">
                                                Row 3, cell 2
                                            </TableCell>
                                        </TableRow>
                                    </Table>`}
                            </pre>
                            <Table className="table">
                                <TableHeaderRow>
                                    <TableHeaderCell colSpan={2}>Title</TableHeaderCell>
                                </TableHeaderRow>
                                <TableSecondaryHeaderRow>
                                    <TableHeaderCell>Column 1</TableHeaderCell>
                                    <TableHeaderCell>Column 2</TableHeaderCell>
                                </TableSecondaryHeaderRow>
                                <TableRow className="row">
                                    <TableCell className="td" dataLabel="Column 1">
                                        Row 1, cell 1
                                    </TableCell>
                                    <TableCell className="td" dataLabel="Column 2">
                                        Row 1, cell 2
                                    </TableCell>
                                </TableRow>
                                <TableRow className="row">
                                    <TableCell className="td" dataLabel="Column 1">
                                        Row 2, cell 1
                                    </TableCell>
                                    <TableCell className="td" dataLabel="Column 2">
                                        Row 2, cell 2
                                    </TableCell>
                                </TableRow>
                                <TableRow className="row">
                                    <TableCell className="td" dataLabel="Column 1">
                                        Row 3, cell 1
                                    </TableCell>
                                    <TableCell className="td" dataLabel="Column 2">
                                        Row 3, cell 2
                                    </TableCell>
                                </TableRow>
                            </Table>
                        </Grid>
                    </Grid>
                </Grid>
            </ColumnLayout>
        );
    }
}

const styles = () => ({
    buttonList: {},
    // v5 Grid spacing={1} uses 8px margins/padding (v4 used 4px).
    // Force v4 values so both Grid-item and non-Grid-item children align correctly.
    outerGrid: {
        margin: -4,
        width: 'calc(100% + 8px)',
        '& > .MuiGrid-item': {
            padding: 4
        }
    }
});
export default compose(withSnackbarMessage, withTheme, withStyles(styles))(IconsPreview);
